<template>
    <PageStyleComponent :key="mainComponentKey" :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader">
        <template v-slot:body>
            <div class="border border-slate-200 rounded relative py-1.5 mt-3 px-2 min-h-[750px]">
                <h1 class="font-bold absolute top-[-13px] left-5 bg-white">Employee Details</h1>
                <div class="tabs pt-2">
                    <button v-for="(tab, index) in tabs" :key="tab" :class="['tab', { active: activeTab === index }]"@click="selectTab(index)">
                        {{ tab }}
                    </button>
                </div>
                <div class="tab-content mt-3">
                    <div v-if="activeTab == 0">
                        <div class="flex">
                            <!-- Passport Photo -->
                            <div class="basis-1/6 flex flex-col items-center">
                                <div class="w-36 h-44 border-2 border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
                                    <!-- Display image if available -->
                                    <img v-if="employeeDetails.profile_picture" :src="employeeDetails.profile_picture" alt="Employee Photo" class="w-full h-full object-cover"/>
                                    <!-- Placeholder -->
                                    <div v-else class="text-center text-gray-400 text-sm px-2">
                                        No Photo
                                    </div>
                                </div>
                                <!-- Upload -->
                                <label @click="selectProfilePicture" class="mt-4 px-4 py-2 font-medium border transition rounded cursor-pointer bg-green-100 text-green-600 border-green-300 hover:bg-green-200'">
                                    Upload Photo
                                </label>

                            </div>
                            <div class="basis-1/2 border-left border-gray-400 uppercase">
                                <h1 class="font-bold mb-10">Employee Biodata</h1>
                                <table class="w-full">
                                    <tr class="text-left">
                                        <td class="font-bold ">Staff No:</td>
                                        <td> {{ employeeDetails.staff_number }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold">Employee Name:</td>
                                        <td class="uppercase">{{ employeeDetails.employee_name }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Email:</td>
                                        <td>{{ employeeDetails.email }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold">Phone No:</td>
                                        <td>{{ employeeDetails.phone_number }}</td>
                                        
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">ID Number:</td>
                                        <td>{{ employeeDetails.id_number }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Pin No:</td>
                                        <td>{{ employeeDetails.kra_pin }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Job Title:</td>
                                        <td class="uppercase">{{ employeeDetails.job_title }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Employment Status:</td>
                                        <td class="uppercase">{{ employeeDetails.employment_status }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Address:</td>
                                        <td class="uppercase">{{ employeeDetails.address }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Employment Date:</td>
                                        <td>{{ employeeDetails.employment_start_date }}</td>
                                    </tr>
                                    
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="activeTab == 1" class="text-left">                                 
                        <DynamicTable :key="tableKey" :rightsModule="rightsModule" :columns="loanColumns" :rows="computedLoanRows" :idField="idFieldLoan" :showTotals="hideTotals" :groupingKey=true :actions="actionsLoans" @action-click="loanActionClick" />
                    </div> 
                    <div v-show="activeTab == 2">                  
                        <DynamicTable :key="documentTableKey" :rightsModule="rightsModule" :showTotals="showTotals" :columns="advanceColumns" :rows="computedAdvancesRows" :idField="idFieldDocument" :actions="actionsAdvances" :showActions=false @link-db-click="handleOpenLink"/>
                    </div> 
                    <div v-show="activeTab == 3">                  
                        <DynamicTable :key="tokenTableKey" :rightsModule="rightsModule" :columns="leaveColumns" :rows="computedLeaveRows" :idField="idFieldToken" :actions="actionsUtility" @action-click="tokenActionClick" 
                                        :showActions="showActions" :showTotals="hideTotals"/>
                    </div>  
                    <div v-show="activeTab == 4">                  
                        <DynamicTable :key="transferTableKey" :rightsModule="rightsModule" :columns="appraisalColumns" :rows="computedAppraisalsRows" :idField="idFieldTransfer" :actions="actionsUtility" @action-click="transferActionClick" 
                                        :showActions="showActions" :showTotals="hideTotals" />
                    </div>  
                    <div v-show="activeTab == 5">                  
                        <DynamicTable :key="tokenTableKey" :rightsModule="rightsModule" :columns="deductionColumns" :rows="computedDeductionsRows" :idField="idFieldToken" :actions="actionsUtility" @action-click="tokenActionClick" 
                                        :showActions="showActions" :showTotals="showTotals"/>
                    </div> 
                    <div v-show="activeTab == 6">                  
                        <DynamicTable :key="benefitTableKey" :rightsModule="rightsModule" :columns="benefitColumns" :rows="computedBenefitRows" :idField="idFieldBenefit" :actions="actionsBenefits" @action-click="benefitActionClick" 
                                        :showActions="showActions" :showTotals="hideTotals"/>
                    </div> 
                    <div v-show="activeTab == 7">                  
                        <DynamicTable :key="documentTableKey" :groupingKey=true :rightsModule="rightsModule" :columns="documentColumns" :rows="computedDocumentRows" :idField="idFieldDocument" :actions="actionsDocument" @action-click="documentActionClick"/>
                    </div>  
                </div>
            </div>
            <PrintModal v-model:visible="printModalVisible" :title="printTitle" >
                <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
                <div v-else-if="imageUrl" class="w-full h-full flex items-center justify-center bg-gray-100">
                    <img :src="imageUrl" class="max-w-[600px] max-h-[850px] object-contain shadow-lg rounded"  alt="Employee Document" />
                </div>
            </PrintModal>
            <MovableModal v-model:visible="profModalVisible" :title="profTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
                :loader="prof_modal_loader" @showLoader="showProfModalLoader" @hideLoader="hideProfModalLoader" @closeModal="closeProfModal">
                <DynamicForm 
                    :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                    :displayButtons="displayButtons" @handleSubmit="uploadPicture" @handleReset="handleProfReset" @file-changed="handleFileChange"
                />
            </MovableModal>
        </template>
    </PageStyleComponent>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onMounted, computed, watch, reactive } from 'vue';
import PageStyleComponent from '../PageStyleComponent.vue';
import FilterBar from "@/components/FilterBar.vue";
import DynamicTable from '@/components/DynamicTable.vue';
import DynamicForm from '../NewDynamicForm.vue';
import MovableModal from '@/components/MovableModal.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import axios from 'axios';
import PrintModal from '@/components/PrintModal.vue';

export default defineComponent({
    name: 'Employee_Profile',
    components:{
        PageStyleComponent, DynamicTable, MovableModal, DynamicForm,FilterBar, PrintModal
    },
    setup(props,{emit}){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const { formatDate } = useDateFormatter();
        const current_date = new Date();
        const errors = ref([]);
        const upload_file = ref('');
        const filePath = ref('');
        const computedFilePath = ref('');
        const showAddButton = ref(false);
        const dep_modal_loader = ref('none');
        const util_modal_loader = ref('none');
        const tnt_modal_loader = ref('none');
        const rightsModule = ref('MMS');
        const allowedRights = ref([]);
        const depModalVisible = ref(false);
        const printModalVisible = ref(false);
        const profModalVisible = ref(false);
        const prof_modal_loader = ref('none');
        const profTitle = ref('Upload Profile Photo');
        const pdfUrl = ref(null);
        const imageUrl = ref(null);
        const printTitle = ref('Print Document');
        const displayButtons = ref(true);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const tabs = ref(['Employee Details','Loans Applications','Salary Advances','Leave Applications','Appraisals','Deductions/Earnings','Benefits','Documents']);
        const activeTab = ref(0);
        const mainComponentKey = ref(0);
        const tableKey = ref(0);
        const tokenTableKey = ref(0);
        const scheduleTableKey = ref(0);
        const documentTableKey = ref(0);
        const idFieldLoan = ref('loan_application_id');
        const idFieldToken = ref('utility_id');
        const idFieldStatement = ref('');
        const employeeID = computed(()=> store.state.Employees.selectedEmployeeID);
        const computedLoanRows = computed(()=> store.state.Employees.employeeLoans);
        const computedLeaveRows = computed(()=> store.state.Employees.employeeLeaves);
        const computedDeductionsRows = computed(()=> store.state.Employees.emplDeductions);
        const computedBenefitRows = computed(()=> store.state.Employees.employeeBenefits);
        const computedAppraisalsRows = computed(()=> store.state.Employees.employeeAppraisals);
        const computedAdvancesRows = computed(()=> store.state.Employees.salaryAdvances);
        const computedDocumentRows = computed(()=> store.state.Employees.employeeDocuments);
        const employeeDetails = computed(()=> store.state.Employees.employeeDetails);
        const loanColumns = ref([
            {type: "checkbox"},
            {label: "Date", key:"application_date"},
            {label: "Loan No", key:"loan_number"},
            {label: "Applied", key: "formatted_applied_amount"},
            {label: "Approved", key: "formatted_approved_amount"},
            {label: "Disbursed", key: "disbursed"},
            {label: "Status", key:"approval_status" , textColor: "textColor"},
            {label: "Loan Remarks", key:"loan_remarks"},
            {label: "Appr. By", key:"approved_by"},
        ]);
        const showTotals = ref(true);
        const hideTotals = ref(false);
        const actionsLoans = ref([
            {name: 'view', icon: 'fa fa-file-pdf-o', title: 'View Loan', rightName: 'Viewing Loan Ledger'},
        ]);

        const leaveColumns = ref([
            {type: "checkbox"},
            {label: "Date", key:"date"},
            {label: "Start Date", key:"start_date"},
            {label: "End Date", key:"end_date"},
            {label: "Applied", key:"days_requested"},
            {label: "Approved", key:"days_approved", txtColor: "textStatusColor"},
            {label: "Status", key:"status", textColor: "textColor"},
        ]);
        const advanceColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Month", key:"month"},
            {label: "Year", key:"year"},
            {label: "Amount", key:"formatted_amount", type:"number"},
            {label: "P.V#", key:"journal_no", type: "link"},
            {label: "Notes", key:"notes"},
        ]);
        const actionsAdvances = ref([

        ]);

        const showActions = ref(false);

        const appraisalColumns = ref([
            {type: "checkbox"},
            {label: "Date", key:"appraisal_date"},
            {label: "Period", key: "period_name"},
            {label: "Min", key: "min_weight"},
            {label: "Max", key: "max_weight"},
            {label: "Score", key: "overall_rating"},
            {label: "Comments/Remarks", key:"comments"},
            {label: "Status", key: "status", textColor: "textColor"},
            {label: "Appr. By", key:"reveiewer_name"},
        ]);
        const deductionColumns = ref([
            {type: "checkbox"},
            {label: "Name", key: "deduction_name"},
            {label: "Type", key: "deduction_type"},
            {label: "Recurrent", key: "recurrent"},
            {label: "Amount", key: "amount", type:"number"},
        ]);
        const benefitColumns = ref([
            {type: "checkbox"},
            {label: "Benefit Type", key: "benefit_type"},
            {label: "Charge Mode", key: "charge_mode"},
            {label: "Charge Type", key: "charge_type"},
            {label: "Asset Value", key: "asset_value", type:"number"},
            {label: "Amount", key: "benefit_amount", type:"number"},
        ]);
        const documentColumns = ref([
            {type: "checkbox"},
            {label: "Document Type", key:"document_type", type: "text"},
            {label: "Document Name", key:"document_name", type: "text"},
        ]);
        const actionsDocument = ref([
            {name: 'preview', icon: 'fa fa-paperclip', title: 'View Document',rightName: 'Adding Employee Documents'},
        ]);

        const selectTab = async(index) => {
            showLoader();
            let formData = {
                company: companyID.value,
                employee: employeeID.value
            }
            let formData1 = {
                company: companyID.value,
                employee: employeeDetails.value.employee_id,
                page_size: "1000"
            }
            if( index == 1){
                activeTab.value = index;
                await store.dispatch('Employees/fetchEmployeeDetails',formData)
                .then(()=>{
                    hideLoader();
                })
            }
            else if( index == 3){
                activeTab.value = index;
                hideLoader();
            }else{
                activeTab.value = index;
                hideLoader();
            }

        };

        const showLoader = () =>{
            loader.value = "block";
        };
        const hideLoader = () =>{
            loader.value = "none";
        };

        const loanActionClick = async(rowIndex, action, row) =>{
            if(action == 'view'){
                const applicationID = row[idFieldLoan];
                const applicationStatus = row['approval_status']
                if(applicationStatus == 'Approved'){
                    let formData = {
                        company: companyID.value,
                        loan_application: applicationID
                    }
                    await store.dispatch('Employee_Loan_Applications/fetchLoanDetails',formData).
                    then(()=>{
                        store.commit('pageTab/ADD_PAGE', {'HR':'Loan_Statement'});
                        store.state.pageTab.hrActiveTab = 'Loan_Statement'; 
                    })
                }else{
                    toast.error(`Cannot View ${applicationStatus} Loan`)
                }
            }
        }
        const previewDocument = (formData) =>{
            showLoader();
            axios
            .post("api/v1/preview-employee-document-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const contentType = response.headers["content-type"];
                        const blob = new Blob([response.data], {type: contentType});

                        const url = URL.createObjectURL(blob);

                        if (contentType === "application/pdf") {
                            pdfUrl.value = url;
                            imageUrl.value = null;
                        } else if (contentType.startsWith("image/")) {
                            imageUrl.value = url;
                            pdfUrl.value = null;
                        }

                        printModalVisible.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const documentActionClick = async(rowIndex, action, row) =>{
            if( action == 'preview'){
                const docID = row['employee_document_id'];
                let formData = {
                    employee_document: docID,
                    company: companyID.value
                } 
                previewDocument(formData);
                
            }
        }

        const tokenActionClick = async(rowIndex, action, row) =>{
            
        }
        const handleFileChange = (fileData) =>{
            filePath.value = fileData.filePath;
            upload_file.value = fileData.file;
            console.log('File Path:', filePath.value);
            console.log('File Object:', upload_file.value);
        }
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'file', name: 'file-input',label: "Profile Picture('jpeg','jpg')", value: '', filePath: computedFilePath.value, required: false, placeholder: "", accepted_formats: "image/*", method: handleFileChange}
            ];
        };

        const handleDepReset = () =>{

        }
        const showDepModalLoader = () =>{
            dep_modal_loader.value = "block";
        }
        const hideDepModalLoader = () =>{
            dep_modal_loader.value = "none";
        }
        const additionalFields = ref([

        ]);
        const handleOpenLink = async(row) =>{
            const journalID = row['journal_id'];
            if(journalID != null){
                let formData = {
                    receipt: journalID,
                    client: row['customer_id'],
                    type: 'PMT',
                    company: companyID.value
                }
                const response = await store.dispatch('Journals/previewClientReceipt',formData)
                if (response && response.status === 200) {
                    const blob1 = new Blob([response.data], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob1);
                    pdfUrl.value = url;
                    printModalVisible.value = true;
                    printTitle.value = `Print Vocher ${row['journal_no']}`;
                }
            }else{
                toast.error(`Missing Voucher`)
            }
        }
        const selectProfilePicture = () => {
            profModalVisible.value = true;
            updateFormFields();
        };
        const showProfModalLoader = () =>{
            prof_modal_loader.value = "block";
        };
        const hideProfModalLoader = () =>{
            prof_modal_loader.value = "none";
        };
        const closeProfModal = () =>{
            profModalVisible.value = false;
        };
        const handleProfReset = () =>{
            filePath.value = '';
            upload_file.value = '';
        };
        const uploadPicture = () =>{
            showProfModalLoader();
            let formData = new FormData();
            formData.append('employee', employeeID.value);
            formData.append('profile_picture', upload_file.value);
            formData.append('company', companyID.value);

            errors.value = [];
            if(upload_file.value == ""){
                errors.value.push('Error');
            }

            if(errors.value.length){
                toast.error('No Image Selected');
                hideProfModalLoader();
            }else{
                axios
                .post("api/v1/upload-employee-profile-picture/", formData)
                    .then((response)=>{
                        if(response.status == 200){
                            toast.success(`Success`);
                            profModalVisible.value = false;
                            store.dispatch('Employees/fetchEmployeeDetails',{'company': companyID.value, 'employee': employeeID.value});
                        }
                    })
                .catch((error)=>{
                    console.log(error.message);
                })
                .finally(()=>{
                    hideProfModalLoader();
                })
            }
        };
        // const profilePicture = computed(() => {
        //     if (!employeeDetails.value.profile_picture) return null;

        //     return `${import.meta.env.VITE_API_URL}${employeeDetails.value.profile_picture}`;
        // });

        const isDisabled =(permissionName) =>{
            const permission = allowedRights.value.find(p => p.permission_name === permissionName);
            return permission ? !permission.right_status : true;
        };
        onBeforeMount(()=>{
            employeeDetails.value = store.state.Employees.employeeDetails;
        });
        onMounted(()=>{

        });

        return{
            tabs, activeTab, mainComponentKey, leaveColumns, selectTab, loader, showLoader, hideLoader, formFields, additionalFields,showTotals,
            tableKey,tokenTableKey, idFieldLoan, idFieldToken, computedLoanRows, computedLeaveRows,computedAppraisalsRows,hideTotals,computedDeductionsRows,
            scheduleTableKey, loanColumns, actionsLoans,showActions,employeeDetails,showAddButton, appraisalColumns,deductionColumns,     
            loanActionClick,tnt_modal_loader, dep_modal_loader, util_modal_loader, depModalVisible, displayButtons,
            documentActionClick,advanceColumns,documentTableKey,actionsAdvances,computedAdvancesRows,printModalVisible,pdfUrl, printTitle,
            modal_top, modal_left, modal_width, showDepModalLoader, hideDepModalLoader, handleDepReset,
            flex_basis, flex_basis_percentage, tokenActionClick,rightsModule,isDisabled,handleOpenLink,
            computedBenefitRows, benefitColumns,computedDocumentRows, documentColumns, actionsDocument,documentActionClick,imageUrl,previewDocument,
            handleFileChange,selectProfilePicture,profModalVisible,prof_modal_loader,profTitle,uploadPicture,closeProfModal,showProfModalLoader,hideProfModalLoader,handleProfReset
        }
    }
})
</script>

<style scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.tabs {
    display: flex;
    border-bottom: 1px solid #ccc;
}
.tab {
    padding: 2px 20px 2px 20px;
    cursor: pointer;
}

.tab.active {
    border-bottom: 2px solid #000;
}

.tab-content {
    padding: 1px;
}

.table{
    min-height: 15vh;
    max-height: 15vh;
    overflow-y: scroll;
    overflow-x: scroll;
}

</style>